import * as Types from '../../../../__generated__/schema';

import { GraphQLError } from 'graphql';
import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GenerateAIAttachmentUploadUrlVariables = Types.Exact<{
  contentType: Types.Scalars['String']['input'];
}>;

export type GenerateAIAttachmentUploadUrl = {
  generateAIAttachmentUploadUrl: Pick<Types.AIAttachmentUploadUrl, 'uploadUrl' | 's3Url'>;
};

export const GenerateAIAttachmentUploadUrlDocument = gql`
  mutation GenerateAIAttachmentUploadUrl($contentType: String!) {
    generateAIAttachmentUploadUrl(contentType: $contentType) {
      uploadUrl
      s3Url
    }
  }
`;
export type GenerateAIAttachmentUploadUrlMutationFn = Apollo.MutationFunction<
  GenerateAIAttachmentUploadUrl,
  GenerateAIAttachmentUploadUrlVariables
>;

/**
 * __useGenerateAIAttachmentUploadUrl__
 *
 * To run a mutation, you first call `useGenerateAIAttachmentUploadUrl` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateAIAttachmentUploadUrl` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateAiAttachmentUploadUrl, { data, loading, error }] = useGenerateAIAttachmentUploadUrl({
 *   variables: {
 *      contentType: // value for 'contentType'
 *   },
 * });
 */
export function useGenerateAIAttachmentUploadUrl(
  baseOptions?: Apollo.MutationHookOptions<
    GenerateAIAttachmentUploadUrl,
    GenerateAIAttachmentUploadUrlVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<GenerateAIAttachmentUploadUrl, GenerateAIAttachmentUploadUrlVariables>(
    GenerateAIAttachmentUploadUrlDocument,
    options,
  );
}
export type GenerateAIAttachmentUploadUrlHookResult = ReturnType<
  typeof useGenerateAIAttachmentUploadUrl
>;
export type GenerateAIAttachmentUploadUrlMutationResult =
  Apollo.MutationResult<GenerateAIAttachmentUploadUrl>;
export type GenerateAIAttachmentUploadUrlMutationOptions = Apollo.BaseMutationOptions<
  GenerateAIAttachmentUploadUrl,
  GenerateAIAttachmentUploadUrlVariables
>;
export function mockGenerateAIAttachmentUploadUrl({
  data,
  variables,
  errors,
}: {
  data: GenerateAIAttachmentUploadUrl;
  variables?: GenerateAIAttachmentUploadUrlVariables;
  errors?: GraphQLError[];
}) {
  return {
    request: { query: GenerateAIAttachmentUploadUrlDocument, variables },
    result: { data, errors },
  };
}
